import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import {
  IProductCategoryByIdResponse,
  IProductCategoryByIdResponseData,
  ProductCategory
} from '../models/product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoriesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  constructor() {}

  readProductCategories(showLoader = true): Observable<ProductCategory[]> {
    return this.#http.getData(`${this.baseUrl}/products/categories?includingInactive=false`, {
      showLoader,
      showMessage: false
    });
  }

  readProductCategoriesByProductListId(productListId: string): Observable<ProductCategory[]> {
    return this.#http.getData(`${this.baseUrl}/product-lists/${productListId}/categories`, {
      showLoader: true,
      showMessage: false
    });
  }

  readProductCategoriesById(parentId: string): Observable<IProductCategoryByIdResponseData> {
    return this.#http.getData(`${this.baseUrl}/products/categories/${parentId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  createProductCategory(productCategory: ProductCategory): Observable<any> {
    return this.#http.postData(
      `${this.baseUrl}/products/categories`,
      { showLoader: true, showMessage: true },
      productCategory
    );
  }

  updateProductCategory(productCategory: ProductCategory): Observable<any> {
    return this.#http.putData(`${this.baseUrl}/products/categories/${productCategory.id}`, productCategory, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteProductCategory(id: string): Observable<any> {
    return this.#http.deleteData(`${this.baseUrl}/products/categories/${id}`, { showLoader: true, showMessage: true });
  }
}
